import { gql } from '@apollo/client';

export const AVAILABLE_GENERAL_REPORTS_QUERY_NAME = 'AvailableGeneralReports';
export const AVAILABLE_GENERAL_REPORTS = gql`
    query ${AVAILABLE_GENERAL_REPORTS_QUERY_NAME} {
        availableGeneralReports {
            availableReports {
                type
                versions
                formats
                requiredFields
            }
            deliveryYears
            availableMembers {
                memberId
                balancingGroup
            }
        }
    }
`;

export const AVAILABLE_AUCTION_REPORTS_QUERY_NAME = 'AvailableAuctionReports';
export const AVAILABLE_AUCTION_REPORTS = gql`
    query ${AVAILABLE_AUCTION_REPORTS_QUERY_NAME}(
        $auctionId: Int!,
    ) {
        availableAuctionReports(
            auctionId: $auctionId,
        ) {
            availableReports {
                type
                versions
                formats
                requiredFields
            }
            availableMembers {
                memberId
                balancingGroup
            }
        }
    }
`;
